module.exports = __webpack_public_path__ + "static/media/aws.36ddd666.png";